"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerType = void 0;
var PartnerType;
(function (PartnerType) {
    PartnerType["CUSTOMER"] = "customer";
    PartnerType["VENDOR"] = "vendor";
    PartnerType["PROSPECT"] = "prospect";
    PartnerType["OTHER"] = "other";
})(PartnerType = exports.PartnerType || (exports.PartnerType = {}));
//# sourceMappingURL=partner-type.enum.js.map